import React from 'react';

import type { FormFields } from '../types';

import { useI18n } from 'lib/i18n/context';
import FormFieldText from 'ui/shared/forms/fields/FormFieldText';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { CONTRACT_VERIFICATION_FIELD_KEYS } from '../i18n';

interface Props {
  isVyper?: boolean;
}

const ContractVerificationFieldCode = ({ isVyper }: Props) => {
  const { t } = useI18n();
  return (
    <ContractVerificationFormRow>
      <FormFieldText<FormFields>
        name="code"
        isRequired
        placeholder={ t(CONTRACT_VERIFICATION_FIELD_KEYS.code.placeholder) }
        size={{ base: 'md', lg: 'lg' }}
        asComponent="Textarea"
      />
      { isVyper ? null : (
        <span>{ t(CONTRACT_VERIFICATION_FIELD_KEYS.code.hint) }</span>
      ) }
    </ContractVerificationFormRow>
  );
};

export default React.memo(ContractVerificationFieldCode);
